// extracted by mini-css-extract-plugin
export default {"faqSection":"faqSection__OTBiY","faqHed":"faqHed__NTFiN","faqContent":"faqContent__NThkZ","question":"question__MTBmM","answer":"answer__ZWY1M"};